import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import React, { useEffect, useMemo } from 'react';
import { IGetCustomerLanguages } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getCustomerLanguages } from 'backend/customers';
import { useTranslation } from 'react-i18next';

interface ILanguagesMultipleSelect {
	setIDsLanguages: (value: string[]) => void;
	IDSelectedCustomer: Nullable<string>;
	IDDefaultLanguage: Nullable<string>;
	IDsLanguages: string[];
}

const LanguagesMultipleSelect: React.FC<ILanguagesMultipleSelect> = ({
	IDSelectedCustomer,
	IDDefaultLanguage,
	IDsLanguages,
	setIDsLanguages,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetCustomerLanguages, string>(
		IDSelectedCustomer ? getCustomerLanguages : null,
		IDSelectedCustomer || '',
	);
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('selectOneLanguage') },
			() => ({
				validator() {
					if (IDDefaultLanguage && IDsLanguages.includes(IDDefaultLanguage)) {
						return Promise.resolve();
					}
					return Promise.reject(new Error(t('mustContainDefaultLanguage')));
				},
			}),
		],
		[IDDefaultLanguage, IDsLanguages, t],
	);

	useEffect(() => {
		refetch();
	}, [IDSelectedCustomer]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return (
			response?.data.languages.map((el) => ({
				id: el.id,
				name: tForm(el.name),
			})) || []
		);
	}, [tForm, response]);

	return (
		<FormSelect
			testId="LanguagesMultipleSelect"
			name="IDsLanguages"
			label="languagesLabel"
			options={mappedOptions}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setIDsLanguages}
			disabled={!IDSelectedCustomer}
			validationRules={validationRules}
			mode="multiple"
			showSearch={false}
		/>
	);
};

export default React.memo(LanguagesMultipleSelect);
